import { Item, Name, DeleteBtn } from "./ContactItem.styled.js";

export const ContactItem = ({ contact, onDelete }) => {
  return (
    <Item>
      <Name>
        {contact.name}: {contact.number}
      </Name>
      <DeleteBtn onClick={() => onDelete(contact.id)}>Delete</DeleteBtn>
    </Item>
  );
};
